export interface AppConfig {
  ABOUT_US_URL: string
  AUTH_SERVICE_URL: string
  AVATARS_URL: string
  CALL_REPORTS: string
  ANALYTICS_CALL_REPORTS: string
  CLIENT_ID: string
  DEFAULT_APP: string
  DEFAULT_GTC_BILLING_APP: string
  ENV_KEY?: string
  EXTERNAL_ADMIN_URL: string
  EXTERNAL_ADMIN_PORTAL_URL: string
  PARTNER_ADMIN_URL: string
  PARTNER_EXCHANGE_URL: string
  IS_LOCAL_ENV: boolean
  PRIVACY_POLICY_URL: string
  PROFILE_URL: string
  QUALTRICS_GUIDED_SETUP_SURVEY_URL: string
  SEGMENT_WRITE_KEY: string
  SENTRY_ENABLED: boolean
  SUPPORT_URL: {
    en: string
    fr: string
    de: string
    it: string
    es: string
    pt: string
  }
  JIVE_SYSTEM_STATUS_URL: string
  SYSTEM_STATUS_URL: string
  TOS_URL: string
  OLD_ADMIN_PORTAL: string
  QUALTRICS_GOTOADMIN_FEEDBACK_SURVEY_URL: string
  QUALTRICS_GOTOADMIN_CES_OSAT_SURVEY_ID: string
  QUALTRICS_GOTOADMIN_CES_OSAT_SURVEY_URL: string
  LOCATIONS_BFF_URL: string
  RESOLVE_SUPPORT_URL: string
  RESOLVE_SYSTEM_STATUS_URL: string
  TUTORIALS_AND_VIDEOS_URL: string
  UNIFIED_COMMERCE_SERVICE_URL: string
  GOTORESOLVE_ECOM_URL: string
  LOGGING_SERVICE_URL: string
  LOGGER_SETTINGS_LOG_TO_CONSOLE: boolean
  GTC_BILLING_BFF: string
}

const common = {
  ABOUT_US_URL: 'https://www.logmeininc.com/about-us',
  DEFAULT_APP: 'products',
  DEFAULT_GTC_BILLING_APP: 'gtc-billing',
  PRIVACY_POLICY_URL: 'https://www.logmeininc.com/legal/privacy',
  SENTRY_ENABLED: false,
  SUPPORT_URL: {
    en: 'https://support.goto.com/admin',
    fr: 'https://support.goto.com/fr/admin',
    de: 'https://support.goto.com/de/admin',
    it: 'https://support.goto.com/it/admin',
    es: 'https://support.goto.com/es/admin',
    pt: 'https://support.goto.com/pt/admin',
  },
  PARTNER_EXCHANGE_URL: 'https://partnerexchange.logmeininc.com',
  SYSTEM_STATUS_URL: 'https://status.gotomeeting.com/',
  JIVE_SYSTEM_STATUS_URL: 'https://status.goto.com/',
  TOS_URL: 'https://www.logmeininc.com/legal/terms-and-conditions',
  RESOLVE_SUPPORT_URL: 'https://support.goto.com/resolve',
  RESOLVE_SYSTEM_STATUS_URL: 'https://status.gotoresolve.com',
  TUTORIALS_AND_VIDEOS_URL: 'https://link.goto.com/EmbAdminInProductUX',
  QUALTRICS_GOTOADMIN_CES_OSAT_SURVEY_ID: 'ZN_bISPmT7egwSbiB0',
  QUALTRICS_GOTOADMIN_CES_OSAT_SURVEY_URL:
    'https://znbispmt7egwsbib0-logmeinvoc.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_bISPmT7egwSbiB0',
}

const appConfig: { [key in 'local' | 'development' | 'staging' | 'production']: AppConfig } = {
  local: {
    ...common,
    AUTH_SERVICE_URL: 'https://identity.ed1.goto.com',
    AVATARS_URL: 'https://avatarsed1.serversdev.getgo.com',
    CALL_REPORTS: 'https://my.dev.jive.com/cr',
    ANALYTICS_CALL_REPORTS: 'https://app.dev.gtc.goto.com/analytics',
    CLIENT_ID: '34b82774-7bf7-470d-9f1f-0b871dd525e0',
    ENV_KEY: 'local',
    EXTERNAL_ADMIN_URL: 'https://iamed1.serversdev.getgo.com',
    EXTERNAL_ADMIN_PORTAL_URL: 'http://localhost:9000/src/main/webapp',
    PARTNER_ADMIN_URL: 'https://partner.dev.aur.goto.com',
    IS_LOCAL_ENV: true,
    PROFILE_URL: 'https://profileed.serversdev.getgo.com/personal-info',
    QUALTRICS_GUIDED_SETUP_SURVEY_URL: 'https://logmeinvoc.iad1.qualtrics.com/jfe/form/SV_6eQJulktsTKAoOG?',
    QUALTRICS_GOTOADMIN_FEEDBACK_SURVEY_URL: 'https://logmeinvoc.iad1.qualtrics.com/jfe/form/SV_3y0WQyODdk3IWh0',
    SEGMENT_WRITE_KEY: '80bfwLnkToKZDimNPNt9YyVsE27JXFXi',
    OLD_ADMIN_PORTAL: 'https://my.dev.jive.com/pbx/',
    LOCATIONS_BFF_URL: 'https://api.dev.jive.com/unified-admin-locations-bff/',
    UNIFIED_COMMERCE_SERVICE_URL: 'https://commerceed.serversdev.getgo.com/unifiedcommerceservice/rest',
    GOTORESOLVE_ECOM_URL: 'https://buydevcm.goto.com/resolve/customize',
    LOGGING_SERVICE_URL: 'https://logginged1.getgo.test.expertcity.com',
    LOGGER_SETTINGS_LOG_TO_CONSOLE: true,
    GTC_BILLING_BFF: 'https://api.dev.jive.com/billing-portal-bff/v1',
  },
  development: {
    ...common,
    AUTH_SERVICE_URL: 'https://identity.ed1.goto.com',
    AVATARS_URL: 'https://avatarsed1.serversdev.getgo.com',
    CALL_REPORTS: 'https://my.dev.jive.com/cr',
    ANALYTICS_CALL_REPORTS: 'https://app.dev.gtc.goto.com/analytics',
    CLIENT_ID: '34b82774-7bf7-470d-9f1f-0b871dd525e0',
    ENV_KEY: 'dev',
    EXTERNAL_ADMIN_URL: 'https://iamed1.serversdev.getgo.com',
    EXTERNAL_ADMIN_PORTAL_URL: 'https://admined1.lmiinc.test.expertcity.com/portal',
    PARTNER_ADMIN_URL: 'https://partner.dev.aur.goto.com',
    IS_LOCAL_ENV: false,
    PROFILE_URL: 'https://profileed.serversdev.getgo.com/personal-info',
    QUALTRICS_GUIDED_SETUP_SURVEY_URL: 'https://logmeinvoc.iad1.qualtrics.com/jfe/form/SV_6eQJulktsTKAoOG?',
    QUALTRICS_GOTOADMIN_FEEDBACK_SURVEY_URL: 'https://logmeinvoc.iad1.qualtrics.com/jfe/form/SV_3y0WQyODdk3IWh0',
    SEGMENT_WRITE_KEY: '80bfwLnkToKZDimNPNt9YyVsE27JXFXi',
    OLD_ADMIN_PORTAL: 'https://my.dev.jive.com/pbx/',
    LOCATIONS_BFF_URL: 'https://api.dev.jive.com/unified-admin-locations-bff/',
    UNIFIED_COMMERCE_SERVICE_URL: 'https://commerceed.serversdev.getgo.com/unifiedcommerceservice/rest',
    GOTORESOLVE_ECOM_URL: 'https://buydevcm.goto.com/resolve/customize',
    LOGGING_SERVICE_URL: 'https://logginged1.getgo.test.expertcity.com',
    LOGGER_SETTINGS_LOG_TO_CONSOLE: true,
    GTC_BILLING_BFF: 'https://api.dev.jive.com/billing-portal-bff/v1',
  },
  staging: {
    ...common,
    AUTH_SERVICE_URL: 'https://identity.stage.goto.com',
    AVATARS_URL: 'https://avatarsed1.serversdev.getgo.com', // TODO: check what should this be
    CALL_REPORTS: 'https://my.staging.jive.com/cr',
    ANALYTICS_CALL_REPORTS: 'https://app.staging.gtc.goto.com/analytics',
    CLIENT_ID: 'd786f5fe-130d-4654-975b-f494be3d5e8d',
    ENV_KEY: 'staging',
    EXTERNAL_ADMIN_URL: 'https://iamstage.servers.getgo.com',
    EXTERNAL_ADMIN_PORTAL_URL: 'https://adminstage.logmeininc.com/portal',
    PARTNER_ADMIN_URL: 'https://partner.staging.aur.goto.com',
    IS_LOCAL_ENV: false,
    PROFILE_URL: 'https://profilestage.servers.getgo.com/personal-info',
    QUALTRICS_GUIDED_SETUP_SURVEY_URL: 'https://logmeinvoc.iad1.qualtrics.com/jfe/form/SV_6eQJulktsTKAoOG?',
    QUALTRICS_GOTOADMIN_FEEDBACK_SURVEY_URL: 'https://logmeinvoc.iad1.qualtrics.com/jfe/form/SV_3y0WQyODdk3IWh0',
    SEGMENT_WRITE_KEY: 'GPpnYV9MoHNiPQ1S2xKBlv3J3lpBKJVX',
    OLD_ADMIN_PORTAL: 'https://my.staging.jive.com/pbx/',
    LOCATIONS_BFF_URL: 'https://api.staging.jive.com/unified-admin-locations-bff/',
    SENTRY_ENABLED: true,
    UNIFIED_COMMERCE_SERVICE_URL: 'https://commercestage.servers.getgo.com/unifiedcommerceservice/rest',
    GOTORESOLVE_ECOM_URL: 'https://buyreview.goto.com/resolve/customize',
    LOGGING_SERVICE_URL: 'https://loggingstage.getgo.com',
    LOGGER_SETTINGS_LOG_TO_CONSOLE: false,
    GTC_BILLING_BFF: 'https://api.staging.jive.com/billing-portal-bff/v1',
  },
  production: {
    ...common,
    AUTH_SERVICE_URL: 'https://identity.goto.com',
    AVATARS_URL: 'https://avatars.servers.getgo.com',
    CALL_REPORTS: 'https://my.jive.com/cr',
    ANALYTICS_CALL_REPORTS: 'https://app.goto.com/analytics',
    CLIENT_ID: '69da7cb9-48bf-42f1-adaa-df02e919c454',
    EXTERNAL_ADMIN_URL: 'https://iam.servers.getgo.com',
    EXTERNAL_ADMIN_PORTAL_URL: 'https://admin.logmeininc.com/portal',
    PARTNER_ADMIN_URL: 'https://partner.goto.com',
    IS_LOCAL_ENV: false,
    PROFILE_URL: 'https://profile.logmeininc.com/personal-info',
    QUALTRICS_GUIDED_SETUP_SURVEY_URL: 'https://logmeinvoc.iad1.qualtrics.com/jfe/form/SV_ezEZv0sPrYfCFIW?',
    QUALTRICS_GOTOADMIN_FEEDBACK_SURVEY_URL: 'https://logmeinvoc.iad1.qualtrics.com/jfe/form/SV_0olNf8KLPgd1uU6',
    QUALTRICS_GOTOADMIN_CES_OSAT_SURVEY_ID: 'ZN_daogXHqCKjaUGUe',
    QUALTRICS_GOTOADMIN_CES_OSAT_SURVEY_URL:
      'https://znbispmt7egwsbib0-logmeinvoc.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_daogXHqCKjaUGUe',
    SENTRY_ENABLED: true,
    SEGMENT_WRITE_KEY: 'GPpnYV9MoHNiPQ1S2xKBlv3J3lpBKJVX',
    OLD_ADMIN_PORTAL: 'https://my.jive.com/pbx/',
    LOCATIONS_BFF_URL: 'https://api.jive.com/unified-admin-locations-bff/',
    UNIFIED_COMMERCE_SERVICE_URL: 'https://commerce.servers.getgo.com/unifiedcommerceservice/rest',
    GOTORESOLVE_ECOM_URL: 'https://buy.goto.com/resolve/customize',
    LOGGING_SERVICE_URL: 'https://logging.getgo.com',
    LOGGER_SETTINGS_LOG_TO_CONSOLE: false,
    GTC_BILLING_BFF: 'https://api.jive.com/billing-portal-bff/v1',
  },
}

export default appConfig
